import { render, staticRenderFns } from "./photographySalaryAccountingSummary.vue?vue&type=template&id=6887baf2&scoped=true&"
import script from "./photographySalaryAccountingSummary.vue?vue&type=script&lang=js&"
export * from "./photographySalaryAccountingSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6887baf2",
  null
  
)

export default component.exports